import React from "react";
import styled from "styled-components";
import isJFK from "utils/helperFunctions";

const shouldStyleVariant = isJFK();
const capitalizedVariants = ["header", "label"];
const coloredVariants = ["header"];

const Text = (props) => {
  return (
    <CustomText {...props} style={props.style} className={props.className}>
      {props.children}
    </CustomText>
  );
};

export const CustomText = styled.p`
  font-family: ${({ fontFamily, theme }) =>
    fontFamily || "var(--font-primary)" || theme.fonts.primary};
  font-weight: ${({ weight }) => weight};
  font-size: ${({ size }) => size};
  color: ${({ color, variant }) =>
    coloredVariants.includes(variant) && shouldStyleVariant
      ? "var(--primary-foreground)"
      : color};

  text-transform: ${({ variant }) =>
    capitalizedVariants.includes(variant) && shouldStyleVariant
      ? "uppercase"
      : "none"};
`;

export default Text;
